// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEmployeeDependentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteEmployeeDependentMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEmployeeDependent'
>;

export const DeleteEmployeeDependentDocument = /*#__PURE__*/ gql`
    mutation deleteEmployeeDependent($id: ID!) {
  deleteEmployeeDependent(id: $id)
}
    `;
export type DeleteEmployeeDependentMutationFn = Apollo.MutationFunction<
  DeleteEmployeeDependentMutation,
  DeleteEmployeeDependentMutationVariables
>;

/**
 * __useDeleteEmployeeDependentMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeDependentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeDependentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeDependentMutation, { data, loading, error }] = useDeleteEmployeeDependentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeDependentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeDependentMutation, DeleteEmployeeDependentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeDependentMutation, DeleteEmployeeDependentMutationVariables>(
    DeleteEmployeeDependentDocument,
    options,
  );
}
export type DeleteEmployeeDependentMutationHookResult = ReturnType<typeof useDeleteEmployeeDependentMutation>;
export type DeleteEmployeeDependentMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeDependentMutation,
  DeleteEmployeeDependentMutationVariables
>;
